import { Box, Grid } from '@radix-ui/themes';
import { NotifyHelper } from 'classes/helpers/notify.helper';
import { CommonDateRangeInput } from 'components/common/form/date/range';
import { CommonSearchInput } from 'components/common/form/search';
import {
  MAX_DATE,
  MIN_DATE,
} from 'components/sections/admin-portal/machines/dialogs/settings/machine-session-history/common';
import { SessionEventsContext } from 'contexts/session-events.context';
import { endOfDay, startOfDay } from 'date-fns';
import { t } from 'i18next';
import { StringHelper } from 'lib_ts/classes/string.helper';
import { LOCAL_DATEPICKER_FORMAT } from 'lib_ts/enums/datetime.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useContext, useEffect, useState } from 'react';
import { MachinesService } from 'services/machines.service';

export const SessionsToolbar = () => {
  const { filters, mergeFilters } = useContext(SessionEventsContext);
  const [machineIDs, setMachineIDs] = useState<string[]>([]);

  useEffect(() => {
    const getTeamMachines = async () => {
      const machines = await MachinesService.getInstance().getTeamMachines();

      setMachineIDs(
        machines
          .map((m) => m.machineID)
          .sort((a, b) => StringHelper.safeSort(a, b))
      );
    };

    getTeamMachines();
  }, []);

  return (
    <Grid columns="4" gap={RADIX.FLEX.GAP.SM}>
      <Box gridColumn="span 2">
        <CommonSearchInput
          id="filter-machine"
          placeholder="common.machine"
          options={machineIDs.map((o) => ({
            label: o,
            value: o,
          }))}
          values={filters.machineIDs}
          onChange={(v) => {
            if (v.length === 0) {
              NotifyHelper.warning({
                message_md:
                  'At least one machine must be selected to perform this action.',
              });
              return;
            }

            mergeFilters({ machineIDs: v });
          }}
          multiple
          required
          strict
        />
      </Box>
      <Box gridColumn="span 2">
        <CommonDateRangeInput
          id="date-range"
          displayFormat={LOCAL_DATEPICKER_FORMAT}
          minDate={MIN_DATE}
          maxDate={MAX_DATE}
          placeholder="Date Range"
          defaultStartValue={filters.dateRange?.start}
          defaultEndValue={filters.dateRange?.end}
          onChange={(values) => {
            if (!values) {
              NotifyHelper.warning({
                message_md: t('common.check-inputs-msg'),
              });
              return;
            }

            if (!values.start || !values.end) {
              return;
            }

            mergeFilters({
              dateRange: {
                start: startOfDay(values.start),
                end: endOfDay(values.end),
              },
            });
          }}
        />
      </Box>
    </Grid>
  );
};
